<div class="header-bar">
  <h1>User Requests</h1>
</div>
<div class="content-container" style="position: relative">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="ui-g filterPanel">
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input
            name="Organisation"
            type="text"
            pInputText
            [(ngModel)]="filterVal.filters.organisation.value"
          />
          <label>Organisation</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <p-dropdown
          name="organisationSubTypeName"
          [options]="organisationSubTypes"
          [(ngModel)]="filterVal.filters.organisationSubTypeId.value"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <p-dropdown
          name="Status"
          [options]="statuses"
          [(ngModel)]="filterVal.filters.status.value"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="Email" type="text" pInputText [(ngModel)]="filterVal.filters.email.value" />
          <label>Email</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input
            name="PhoneNumber"
            type="tel"
            pInputText
            [(ngModel)]="filterVal.filters.phoneNumber.value"
          />
          <label>Phone Number</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <button pButton type="submit" label="Search"></button>
        <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
      </div>
    </div>
  </form>

  <p-table
    #dataTable
    [value]="page.items"
    [lazy]="true"
    [rows]="10"
    [paginator]="true"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event)"
    rowHover="true"
    selectionMode="single"
    [(selection)]="selectedUserRequest"
    [responsive]="true"
  >
    <ng-template pTemplate="header" let-item>
      <tr (dblclick)="showDetais(item)">
        <th pSortableColumn="createDate">Created Date</th>
        <th pSortableColumn="companyName">Organisation</th>
        <th pSortableColumn="statusText">Status</th>
        <th pSortableColumn="organisationSubTypeName">Organisation Type</th>
        <th pSortableColumn="emailAddress">Email</th>
        <th pSortableColumn="phoneNumber">Phone Number</th>
        <th>Registration Channel</th>
        <th>Supplier Type</th>
        <th>Self Billing Accepted</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item">
        <td>
          {{ item.createDate | datelocal : "ddd DD MMM 'YY HH:mm" }}
        </td>
        <td>
          <span *ngIf="item.organisationSubTypeId == 1 || item.organisationSubTypeId == 4">
            {{ item.firstName + ' ' + item.surname }}
          </span>
          <span
            *ngIf="
              item.organisationSubTypeId == 2 ||
              item.organisationSubTypeId == 3 ||
              item.organisationSubTypeId == 5 ||
              item.organisationSubTypeId == 6
            "
          >
            {{ item.companyName }}
          </span>
        </td>
        <td>{{ item.statusText }}</td>
        <td>{{ item.organisationSubTypeName }}</td>
        <td style="overflow: hidden">{{ item.emailAddress }}</td>
        <td>{{ item.phoneNumber }}</td>
        <td>{{ item.userRequestChannelName }}</td>
        <td>{{ item.supplierSignupTypeName }}</td>
        <td>{{ item.selfBillingAccepted ? 'Yes' : 'No' }}</td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DATATABLE DEPRECATED ---
  <p-dataTabl #dataTable [value]="page.items" [lazy]="true" [editable]="tru" [rows]="10" [paginator]="true" [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)" rowHover="true" selectionMode="single" [(selection)]="selectedUserRequest"
      (onRowDblclick)="showDetais($event.data)" [responsive] = "true">
      <p-column field="createDate" header="Created Date" [sortable]="tru">
          <ng-template let-request="rowData" pTemplate="body">
              {{ request.createDate | datelocal:'ddd DD MMM \'YY HH:mm' }}
          </ng-template>
      </p-column>
      <p-column header="Organisation" [sortable]="false">
          <ng-template let-userRequest="rowData" pTemplate="body">
              <span *ngIf="userRequest.organisationSubTypeId == 1 || userRequest.organisationSubTypeId == 4">
                  {{ userRequest.firstName + " " + userRequest.surname}}
              </span>
              <span *ngIf="userRequest.organisationSubTypeId == 2 || userRequest.organisationSubTypeId == 3
                   || userRequest.organisationSubTypeId == 5 || userRequest.organisationSubTypeId == 6">
                  {{userRequest.companyName}}
              </span>
          </ng-template>
      </p-column>
      <p-column field="status" header="Status" [sortable]="tru">
          <ng-template let-userRequest="rowData" pTemplate="body">
              {{userRequest.statusText}}
          </ng-template>
      </p-column>
      <p-column field="organisationSubTypeName" header="Organisation Type" [sortable]="tru"></p-column>
      <p-column field="emailAddress" header="Email" [sortable]="tru"></p-column>
      <p-column field="phoneNumber" header="Phone Number" [sortable]="tru"></p-column>

  </p-dataTable>

  -->

  <!-- DETAILS DIALOG FOR Supplier Individual and Customer Individual -->
  <p-dialog
    header="User Request Details"
    [(visible)]="isShowDetails"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '500px' }"
  >
    <div *ngIf="selectedUserRequest">
      <div
        *ngIf="
          selectedUserRequest.organisationSubTypeId == 1 ||
          selectedUserRequest.organisationSubTypeId == 4
        "
      >
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="firstName">First Name</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="firstName" [ngModel]="selectedUserRequest.firstName" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="surname">Surname</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="surname" [ngModel]="selectedUserRequest.surname" />
            </div>
          </div>
          <div class="ui-g-12">
            <h2>Home Address</h2>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="addressLine1">Address Line 1</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="addressLine1" [ngModel]="selectedUserRequest.addressLine1" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="addressLine2">Address Line 2</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="addressLine2" [ngModel]="selectedUserRequest.addressLine2" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="addressLine3">Address Line 3</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="addressLine3" [ngModel]="selectedUserRequest.addressLine3" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="town">Town</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="town" [ngModel]="selectedUserRequest.town" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="postcode">Postcode</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="postcode" [ngModel]="selectedUserRequest.postcode" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="phoneNumber">Mobile Number</label>
            </div>
            <div class="ui-g-8">
              <input
                pInputText
                type="tel"
                id="phoneNumber"
                [ngModel]="selectedUserRequest.phoneNumber"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="emailAddress">Email Address</label>
            </div>
            <div class="ui-g-8">
              <input pInputText id="emailAddress" [ngModel]="selectedUserRequest.emailAddress" />
            </div>
          </div>
        </div>
      </div>

      <!-- DETAILS DIALOG FOR ALL BUT INDIVIDUALS -->
      <div
        *ngIf="
          selectedUserRequest.organisationSubTypeId == 2 ||
          selectedUserRequest.organisationSubTypeId == 3 ||
          selectedUserRequest.organisationSubTypeId == 5 ||
          selectedUserRequest.organisationSubTypeId == 6
        "
      >
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="companyName">Company Name</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="companyName" [ngModel]="selectedUserRequest.companyName" />
            </div>
          </div>
          <div class="ui-g-12">
            <h2>Registered Address</h2>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="addressLine1">Address Line 1</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="addressLine1" [ngModel]="selectedUserRequest.addressLine1" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="addressLine2">Address Line 2</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="addressLine2" [ngModel]="selectedUserRequest.addressLine2" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="addressLine3">Address Line 3</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="addressLine3" [ngModel]="selectedUserRequest.addressLine3" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="postcode">Postcode</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="postcode" [ngModel]="selectedUserRequest.postcode" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="phoneNumber">Telephone Number</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input
                pInputText
                type="tel"
                id="phoneNumber"
                [ngModel]="selectedUserRequest.phoneNumber"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="surname">Company Registration Number</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input
                pInputText
                id="companyRegistrationNumber"
                [ngModel]="selectedUserRequest.companyRegistrationNumber"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="vatNumber">VAT Number</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="vatNumber" [ngModel]="selectedUserRequest.vatNumber" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="website">Website</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="website" [ngModel]="selectedUserRequest.website" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4 ui-sm-12">
              <label for="emailAddress">Email Address</label>
            </div>
            <div class="ui-g-8 ui-sm-12">
              <input pInputText id="emailAddress" [ngModel]="selectedUserRequest.emailAddress" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="float: right">
      <button
        *ngIf="showConfirmButton"
        type="button"
        pButton
        icon="fa ui-icon-done"
        (click)="confirm(selectedUserRequest, false)"
        label="Confirm"
        [disabled]="!selectedUserRequest"
        class="ui-button green-btn"
      ></button>
      <button
        *ngIf="showResendButton"
        type="button"
        pButton
        icon="fa ui-icon-done"
        (click)="confirm(selectedUserRequest, true)"
        label="Resend Invitation"
        [disabled]="!selectedUserRequest"
        class="ui-button green-btn"
      ></button>
      <button
        *ngIf="showConfirmButton"
        type="button"
        pButton
        icon="fa ui-icon-block"
        (click)="refuse(selectedUserRequest)"
        label="Refuse"
        [disabled]="!selectedUserRequest"
        class="ui-button ui-button-danger"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="closeDetailsDialog()"
      ></button>
    </div>
  </p-dialog>

  <!-- DIALOG FOR REJECT -->
  <p-dialog
    header="Refuse User Request"
    [(visible)]="isShowRefuse"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '500px' }"
  >
    <form
      [formGroup]="refuseUserRequestForm"
      (ngSubmit)="refuseForm(refuseDetails)"
      autocomplete="off"
    >
      <div *ngIf="refuseDetails && refuseDetails.userRequest">
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="sendEmail">Send Email?</label>
            </div>
            <div class="ui-g-8">
              <p-checkbox
                id="sendEmail"
                formControlName="sendEmail"
                [(ngModel)]="refuseDetails.isSendEmail"
                binary="true"
              ></p-checkbox>
            </div>
            api/userrequest
          </div>
          <div class="ui-g-12" *ngIf="refuseDetails.isSendEmail">
            <div class="ui-g-4">
              <label for="reasonForFailure">Reason for failure</label>
            </div>
            <div class="ui-g-8">
              <textarea
                id="reasonForFailure"
                [rows]="8"
                [cols]="40"
                maxlength="1000"
                pInputTextarea
                formControlName="reasonForFailure"
                [autoResize]="false"
                [(ngModel)]="refuseDetails.reasonForFailure"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div style="float: right">
          <button
            type="submit"
            pButton
            icon="fa ui-icon-block"
            label="Refuse"
            class="ui-button ui-button-danger"
            [disabled]="refuseUserRequestForm.invalid && refuseDetails.isSendEmail"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            (click)="closeRefuseDialog()"
          ></button>
        </div>
      </div>
    </form>
  </p-dialog>

  <div class="footerPanel ui-grid-row">
    <button
      *ngIf="showConfirmButton"
      type="button"
      pButton
      icon="fa ui-icon-block"
      (click)="refuse(selectedUserRequest)"
      label="Refuse"
      [disabled]="!selectedUserRequest"
      class="ui-button ui-button-danger btn-to-right"
    ></button>
    <button
      *ngIf="showConfirmButton"
      type="button"
      pButton
      icon="fa ui-icon-done"
      (click)="confirm(selectedUserRequest, false)"
      label="Confirm"
      [disabled]="!selectedUserRequest"
      class="ui-button green-btn btn-to-right"
    ></button>
    <button
      *ngIf="showResendButton"
      type="button"
      pButton
      icon="fa ui-icon-done"
      (click)="confirm(selectedUserRequest, true)"
      label="Resend Invitation"
      [disabled]="!selectedUserRequest"
      class="ui-button green-btn btn-to-right"
    ></button>

    <button
      type="button"
      pButton
      icon="fa ui-icon-open-in-new"
      (click)="showDetais(selectedUserRequest)"
      label="Show Details"
      [disabled]="!selectedUserRequest"
      class="ui-button btn-to-right"
    ></button>
  </div>
  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusy"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 10%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</div>
